import { render, staticRenderFns } from "./section-last-posts.vue?vue&type=template&id=37f0fdda&scoped=true&"
import script from "./section-last-posts.vue?vue&type=script&lang=js&"
export * from "./section-last-posts.vue?vue&type=script&lang=js&"
import style0 from "./section-last-posts.vue?vue&type=style&index=0&id=37f0fdda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f0fdda",
  null
  
)

export default component.exports